import { render, staticRenderFns } from "./RoutesToLeapPage.vue?vue&type=template&id=6387a3df&"
import script from "./RoutesToLeapPage.vue?vue&type=script&lang=js&"
export * from "./RoutesToLeapPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports